import { Component, OnInit } from '@angular/core';
import { WorkExperienceService } from '../../service/work-experience/work-experience.service';
import { WorkExperience } from '../../class/work-experience';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-work-experiences',
  templateUrl: './work-experiences.component.html',
  styleUrls: ['./work-experiences.component.scss']
})
export class WorkExperiencesComponent implements OnInit {

    public promiseForm: Promise<any>;
    public msgs: Message[] = [];
    public workExperience: WorkExperience[];
    public selectWorkExperience: WorkExperience;
    public workExperienceID: Number = 0;
    public modNew = false;
    public modView = false;
    public openWorkExperience = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public workExperiencePosition: string;
    public filters: {key: string, value: string}[];

    public params_id_candidate: number;

    constructor(
        public workExperienceService: WorkExperienceService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_candidate']) {
                this.params_id_candidate = Number(params['id_candidate']);
            }
        });

        this.page = 1;
        this.per_page = 10;
        // if (this.params_id_candidate) {
        //     this.getWorkExperiencesByCandidates(this.params_id_candidate);
        // } else {
        //     this.getWorkExperiences();
        // }
        this.sort = '-start';
    }

    public loadWorkExperienceLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort =  '-' + event.sortField;
            } else {
                this.sort =  event.sortField;
            }
        } else {
            this.sort = '-start';
        }

        if (this.params_id_candidate) {
            this.getWorkExperiencesByCandidates(this.params_id_candidate);
        } else {
            this.getWorkExperiences(event.globalFilter);
        }
    }

    getWorkExperiences(query?: string, filters?: any[]) {
        this.workExperienceService.getWorkExperience(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.workExperience = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getWorkExperiencesByCandidates(id: number, query?: string) {
        this.workExperienceService.getWorkExperienceByRequisition(id, this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.workExperience = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newWorkExperience() {
        this.modNew = !this.modNew;
        this.selectWorkExperience = null;
    }

    public savedWorkExperience(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectWorkExperience = null;
        this.modNew = false;
        // this.getWorkExperiences();
    }

    public cancelWorkExperience (res) {
        this.selectWorkExperience = null;
        this.modNew = false;
        this.modView = false;
        // this.getWorkExperiences();
    }

    public edit(workExperience: WorkExperience) {
        this.modNew = true;
        this.selectWorkExperience = workExperience;
        // this.getWorkExperiences();
    }

    public view(workExperience: WorkExperience) {
        this.openWorkExperience = true;
        this.selectWorkExperience = workExperience;
        this.workExperienceID = workExperience.id;
        this.modView = true;
    }

    public deleteDialog(workExperience: WorkExperience) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(workExperience);
            }
        });
    }

    public delete(workExperience: WorkExperience) {
        this.workExperienceService.deleteWorkExperience(workExperience.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getWorkExperiences();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeWorkExperience(workExperience: WorkExperience) {
        this.putWorkExperience(workExperience);
    }

    public putWorkExperience(values: WorkExperience) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.workExperienceService.updateWorkExperience(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/work-experiences/work-experiences.component.ts